import React, { useEffect } from "react";
import { work } from "../../FaqData/data";
import "./Buildteach.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Buildteach = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 200,
      easing: "ease-in-out",
    });

    window.addEventListener("load", AOS.refresh);
  }, []);

  return (
    <div>
      <div className="build-teach-content-file">
        {work?.map((items, index) => {
          return (
            <div
              key={index}
              className="build-teach-content-data"
              data-aos="fade-down"
              data-aos-duration="1200"
            >
              <div className={items.class}>
                <span className="width-content flex-content-center">
                  {" "}
                  {items.icon && (
                    <items.icon
                      style={{
                        height: window.innerWidth <= 768 ? "100px" : "200px",
                      }}
                    />
                  )}
                </span>
                <div className="width-content">
                  <h3 className="title-text-text">{items.title}</h3>
                  <p className="description-text-text">{items.desc}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Buildteach;
